import { render, staticRenderFns } from "./usage-situation.vue?vue&type=template&id=61b13ffa&"
import script from "./usage-situation.vue?vue&type=script&lang=js&"
export * from "./usage-situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports